export default {
	"RuleClick.ActivityRules": "活動規則"
}